import { makeStyles, Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { PERIOD_SHAPE, SKILL_LIST } from '../../../constants/props';
import Searcher from '../searcher';
import Skill from '../skill';

const useStyles = makeStyles({
  container: {
    minHeight: ({ edit }) => (edit ? '14.375rem' : 'auto'),
    padding: '0.8125rem 1.25rem',
    marginBottom: '1.25rem',
  },
  title: {
    lineHeight: '1.75rem',
    marginBottom: '1rem',
  },
  searcher: {
    width: '20rem',
    marginBottom: '1.875rem',
  },
  skills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '.625rem',
  },
});

const Wrapper = ({ edit, skills, period, onSelectSkill, onDeleteSkill }) => {
  const classes = useStyles({ edit });

  return (
    <Paper className={classes.container}>
      <Typography className={classes.title} variant="h5" color="textSecondary">
        {period.description}
      </Typography>
      {edit && (
        <div className={classes.searcher}>
          <Searcher onSelect={(skill) => onSelectSkill(period, skill)} />
        </div>
      )}
      <div className={classes.skills}>
        {skills.map((skill) =>
          edit ? (
            <Skill
              key={skill.hash}
              {...skill}
              onDelete={() => onDeleteSkill(skill)}
            />
          ) : (
            <Skill key={skill.hash} {...skill} />
          )
        )}
      </div>
    </Paper>
  );
};

Wrapper.defaultProps = {
  edit: false,
  skills: [],
};

Wrapper.propTypes = {
  edit: PropTypes.bool,
  skills: SKILL_LIST,
  period: PERIOD_SHAPE,
  onSelectSkill: PropTypes.func,
  onDeleteSkill: PropTypes.func,
};

export default Wrapper;
